export const CHART_SEGMENT_GEAR_SIZE = 44
export const CHART_SEGMENT_GEAR_INSET = 12
export const CHART_SEGMENT_GEAR_GAP = 8
export const CHART_SEGMENT_GEAR_CLEARANCE =
  CHART_SEGMENT_GEAR_INSET + CHART_SEGMENT_GEAR_SIZE + CHART_SEGMENT_GEAR_GAP

/**
 * Slide header chrome (eyebrow + client logo) occupies the top 51px of a slide.
 * A chart panel that starts above that line must push its gear down, or the gear
 * lands on the logo — which is what matrix-rating did, with its panel at top:8.
 */
export const CHART_SEGMENT_SLIDE_HEADER_HEIGHT = 51

/** Gear inset for a panel whose top edge sits at `panelTop` in slide coordinates. */
export function chartSegmentGearInsetTop(panelTop: number): number {
  return Math.max(
    CHART_SEGMENT_GEAR_INSET,
    CHART_SEGMENT_SLIDE_HEADER_HEIGHT - panelTop + CHART_SEGMENT_GEAR_GAP,
  )
}
